export default {
  home: {
    form: {
      title: 'RECHERCHE - NOUVELLE RESERVATION',
      destination: {
        label: 'destination',
        preloggedLabel: 'Autre lieu de formation non référencé',
        placeholder: 'Où souhaitez-vous aller ?'
      },
      favorite: {
        label:'lieu et hôtel favoris',
        preloggedLabel: 'Lieu de formation référencé',
        location: 'lieu favori',
        hotel:'hôtel favori',
        placeholder: {
          location: 'choisir une destination',
          hotel: 'choisir un hôtel',
        }
      },
      bedrooms: {
        label: 'nombre de chambres',
        single: 'simple couchage',
        double: 'double couchage',
        tooltip_message:'Exemple pour 3 voyageurs: 1 ch. occupée par 1 pers. et 1 ch. occupée par 2 pers.',
        maxRooms: "Pour une occupation de chambre supérieure à {max}, merci de bien vouloir faire une demande de groupe via le formulaire"
      },
      from: {
        label: 'date d\'arrivée',
        placeholder: 'date d\'arrivée'
      },
      to: {
        label: 'date de départ',
        placeholder: 'date de départ'
      },
      services: {
        label: 'services',
        catering: 'Restauration',
        carpark: 'Parking',
        breakfast: 'Petit-déjeuner',
        disabled: 'Accès PMR',
        internet: 'Internet',
        additionals_services: 'services additionnels'
      }
    },
    carry_on:{
      //carry_on:'Je continue',
      choose_one_booking_type: 'Choisissez votre mode de réservation',
      tooltip_message:'Choisissez d\'effectuer votre réservation en ligne (recherche online) ou laissez un agent de réservation l\'effectuer pour vous (demande offline)'
    },
    online:{
      online: 'RECHERCHE ONLINE',
      tooltip_message: 'Effectuez votre recherche et réservez votre hébergement par vous-même.'
    },
    offline:{
      offline: 'DEMANDE OFFLINE',
      tooltip_message:'Complétez le formulaire de demande, votre agent de réservation reviendra vers vous avec une proposition d’hébergement.'
    },
    profile: {
      users_management: 'Gérer les utilisateurs',
      unlogged_url: 'URL de demande de réservation hors-ligne',
      domains_management: "Noms de domaine autorisés pour la création d'utilisateurs",
      no_domain: "Aucun nom de domaine défini. Vous ne pourrez pas créer de nouveaux utilisateurs si vous ne configurez pas les noms de domaine."
    },
    users: {
      users_management: "Gestion des utilisateurs",
      confirmMessage: {
        create: "L'utilisateur a été créé",
        edit: "Les modifications ont été enregistrées"
      }
    },
    opening_an_account:'Ouvrir un compte',
    new_customer:'Nouveau client ?'
  }
}
